import api from './api';

export const authService = {
  /**
   * Login do usuário
   */
  login: async (email, password) => {
    const response = await api.post('/auth/login', { email, password });
    return response;
  },

  /**
   * Registro de novo usuário
   */
  register: async (data) => {
    const response = await api.post('/auth/register', data);
    return response;
  },

  /**
   * Obter dados do usuário logado
   */
  me: async () => {
    const response = await api.get('/auth/me');
    return response;
  },

  /**
   * Logout
   */
  logout: async () => {
    try {
      await api.post('/auth/logout');
    } catch (error) {
      // Ignorar erro de logout
      console.warn('Erro no logout:', error);
    }
  },

  /**
   * Solicitar reset de senha
   */
  forgotPassword: async (email) => {
    const response = await api.post('/auth/forgot-password', { email });
    return response;
  },

  /**
   * Resetar senha
   */
  resetPassword: async (token, password) => {
    const response = await api.post('/auth/reset-password', { token, password });
    return response;
  },

  /**
   * Alterar senha
   */
  changePassword: async (currentPassword, newPassword) => {
    const response = await api.post('/auth/change-password', {
      currentPassword,
      newPassword,
    });
    return response;
  },

  /**
   * Refresh token
   */
  refreshToken: async () => {
    const response = await api.post('/auth/refresh');
    return response;
  },

  /**
   * Verificar e-mail com token
   */
  verifyEmail: async (token) => {
    const response = await api.get('/auth/verify-email', { params: { token } });
    return response;
  },

  /**
   * Reenviar e-mail de verificação
   */
  resendVerification: async (email) => {
    const response = await api.post('/auth/resend-verification', { email });
    return response;
  },

  /**
   * Iniciar configuração do 2FA (gera QR code e backup codes)
   */
  setup2FA: async () => {
    const response = await api.post('/auth/2fa/setup');
    return response;
  },

  /**
   * Verificar código TOTP e ativar 2FA
   */
  verify2FA: async (code) => {
    const response = await api.post('/auth/2fa/verify', { code });
    return response;
  },

  /**
   * Desativar 2FA
   */
  disable2FA: async (password) => {
    const response = await api.post('/auth/2fa/disable', { password });
    return response;
  },

  /**
   * Validar código 2FA durante login
   */
  validate2FA: async (tempToken, code) => {
    const response = await api.post('/auth/2fa/validate', { tempToken, code });
    return response;
  },
};

export default authService;
